var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#6F6F6F",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M13.966 11.18v1.393c0 .766-.627 1.393-1.393 1.393H1.427c-.766 0-1.393-.627-1.393-1.393V11.18",
    transform: "translate(-157 -3020) translate(137 2908) translate(20 112) translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.109 9.76L7.109 0.034",
    transform: "translate(-157 -3020) translate(137 2908) translate(20 112) translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6F6F6F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M7.109 9.76L7.109.034M3.693 6.467L6.994 9.76 10.307 6.479",
    transform: "translate(-157 -3020) translate(137 2908) translate(20 112) translate(3 3)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d5f518ce79a4dbeda8ba38a4d314c5af.svg";
export { ForwardRef as ReactComponent };